
import axios from "axios";
import { useQuery } from '@tanstack/react-query';
import config from "../config.js";

export const usePatientsFullQuery = ({
    searchFilter,
    enabled = true
}) => {

    async function fetchPatients({ queryKey }) {
        const [_key, filtersData] = queryKey;

        return await axios.post(
            `${config.API_URL}/data/patientList`,
            filtersData,
            {
                withCredentials: true
            }
        );

    }

    const getYear = new Date().getFullYear();

    return useQuery(
        {
            queryKey: ['patientsFull',

                {
                    page: 0,
                    pageSize: 10000,
                    // sortField: sortField,
                    // sortOrder: sortOrder,
                    fDocs: searchFilter?.missingDocs,
                    fProforma: searchFilter?.missingProforma,
                    fGOP: searchFilter?.missingGOP,
                    fInvoice: searchFilter?.missingInvoice,
                    fNo: searchFilter?.caseNumber,
                    fMultNo: searchFilter?.caseNumberMult,
                    fadmDateS: searchFilter?.admissionDateStart,
                    fadmDateE: searchFilter?.admissionDateEnd,
                    fName: searchFilter?.name,
                    fLDMCaseNo: searchFilter?.LDMCaseNo,
                    fLDMCaseNoInt: searchFilter?.LDMCaseNoInt,
                    fLDMCaseNoYear: searchFilter?.LDMCaseNoInt ?
                        searchFilter?.LDMCaseNoYear || parseInt(getYear)
                        :
                        null,
                    fHospID: searchFilter?.hospID,
                    FlagError: searchFilter?.FlagError,
                    FlagMessage: searchFilter?.FlagMessage,
                    fUpload: searchFilter?.fUpload,
                    fInsCo: searchFilter?.InsCo,

                }

            ],
            queryFn: fetchPatients,
            enabled: enabled,
            staleTime: 1000 * 60 * 30,



        }




    )



}